import type {GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields as Field} from 'nutshell-graphql-types';

export const getConnectedEntitiesList = (connectedFields: Field[]) => {
    const entitiesList = [];

    if (connectedFields.find((field) => field.entityName === 'CONTACT')) {
        entitiesList.push('people');
    }
    if (connectedFields.find((field) => field.entityName === 'ACCOUNT')) {
        entitiesList.push('companies');
    }
    if (connectedFields.find((field) => field.entityName === 'LEAD')) {
        entitiesList.push('leads');
    }

    if (entitiesList.length === 3) {
        return `${entitiesList[0]}, ${entitiesList[1]}, and ${entitiesList[2]}`;
    } else {
        return entitiesList.join(' and ');
    }
};
